import { Field } from 'formik';
import React, { FC } from 'react';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import Label from '../label/label';
import Togglebox from '../togglebox/togglebox';

const BiometricDetails: FC = () => {
    const { translate } = useLocale()

    return <div>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='biometricType'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.type)}:</Label>
                <Field
                    name="biometricType"
                    type="text"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>

            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='site'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.site)}:</Label>
                <Field
                    name="site"
                    type="text"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
        </div>
        <div className="flex flex-row flex-1 pt-3 ">
            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='ipAddress'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.ipAddress)}:</Label>
                <Field
                    name="ipAddress"
                    type="text"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm bg-gray-input w-full" />
            </div>

            <div className="flex flex-col flex-1 pr-3">
                <Label htmlFor='version'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.version)}:</Label>
                <Field
                    name="version"
                    type="text"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
        </div>
        <div className='flex flex-row flex-1 pt-3'>
            <div className='flex flex-col flex-1 pr-3 justify-center'>
                <Label
                    htmlFor="musteringPoint"
                    className="text-xs text-gray-600 mt-1 my-1">{translate.byKey(TranslationKeys.musteringPoint)}:</Label>
                <div className="my-0">
                    <Togglebox name="musteringPoint" label="" />
                </div>
            </div>
        </div>
    </div>;
};

export default BiometricDetails;